import { ArrowLeftIcon, GiftIcon, SearchIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../../components/Sidebar/Sidebar";
import { apiV3 } from "../../../../utils/helpers/api";
import { useToast } from "../../../../components/Toastr/Toastr";

export default function AddASICExemption() {
  const navigate = useNavigate();
  const { showSuccessToast, showErrorToast } = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [asic, setAsic] = useState<string>("");
  const [asicDetails, setAsicDetails] = useState<any>(null);
  const [company, setCompany] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [id, setId] = useState<string>("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const addExemption = async () => {
    setLoading(true);
    try {
      await apiV3.addExemption(asic, firstName, lastName);
      showSuccessToast("Successfully added an Operations Staff", "");
      navigate("/v3/asic-exemptions");
    } catch (error) {
      console.error("Error occurred while adding an Operations Staff - ", error);
      showErrorToast("An error occurred", "Please try again or contact support");
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      if (!asic) {
        showErrorToast("Please enter an ASIC ID to search.");
        return;
      }
      setLoading(true);
      setAsicDetails(null);
      setCompany("");
      setFirstName("");
      setLastName("");
      setId("");

      const response = await apiV3.getAsicByAsicId(asic);
      if (response.data) {
        setAsicDetails(response.data);
        setCompany(response.data.company || "");
        setFirstName(response.data.firstName || "");
        setLastName(response.data.lastName || "");
        setId(response.data.id || "");
      } else {
        showErrorToast("ASIC not found", "Please ensure you have entered a valid ASIC ID.");
      }
    } catch (err: any) {
      if (err.response && err.response.status === 400) {
        showErrorToast("ASIC not found", "Please ensure you have entered a valid ASIC ID.");
      } else {
        showErrorToast("Error occurred.");
      }
      setAsicDetails(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Sidebar />
      <div className="md:pl-64 flex flex-col flex-1">
        <main className="flex-1">
          {/* Replace with your content */}
          <div className="py-4">
            <div className="px-4 sm:px-6 lg:px-8">
              <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto">
                  <h1 className="text-2xl font-bold text-gray-900 flex flex-row items-center">
                    <GiftIcon className="h-6 w-6 mr-1.5" />
                    Add Operations Staff
                  </h1>
                </div>
                <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                  <button
                    onClick={() => navigate(-1)}
                    type="button"
                    className="inline-flex items-center justify-center rounded-md border border-transparent bg-gray-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:w-auto"
                  >
                    <ArrowLeftIcon className="h-5 w-5 mr-1.5" />
                    Back
                  </button>
                </div>
              </div>
              <div className="mt-8 flex flex-col max-w-screen-md">
                <div className="space-y-8 divide-y divide-gray-200">
                  <div className="space-y-8">
                    <div>
                      <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                        <div className="sm:col-span-4">
                          <label htmlFor="asic" className="block text-sm font-medium text-gray-700">
                            ASIC ID
                          </label>
                          <div className="mt-1 flex rounded-md shadow-sm">
                            <input
                              type="text"
                              name="asic"
                              id="asic"
                              autoComplete="asic"
                              disabled={loading}
                              value={asic}
                              onChange={(e) => setAsic(e.target.value)}
                              className="flex-1 focus:ring-amber-500 focus:border-amber-500 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 disabled:bg-gray-100"
                            />

                            <button
                              onClick={handleSearch}
                              className="inline-flex ml-10 rounded-md border border-transparent bg-gray-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:w-auto"
                            >
                              <SearchIcon className="h-5 w-5 mr-1.5" />
                              Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {asicDetails && (
                      <div>
                        <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                          <div className="sm:col-span-2">
                            <label
                              htmlFor="firstName"
                              className="block text-sm font-medium text-gray-700"
                            >
                              First Name
                            </label>
                            <div className="mt-1 flex rounded-md shadow-sm">
                              <input
                                type="text"
                                name="firstName"
                                id="firstName"
                                disabled
                                value={firstName}
                                className="flex-1 focus:ring-amber-500 focus:border-amber-500 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 disabled:bg-gray-100"
                              />
                            </div>
                          </div>
                          <div className="sm:col-span-2">
                            <label
                              htmlFor="lastName"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Last Name
                            </label>
                            <div className="mt-1 flex rounded-md shadow-sm">
                              <input
                                type="text"
                                name="lastName"
                                id="lastName"
                                disabled
                                value={lastName}
                                className="flex-1 focus:ring-amber-500 focus:border-amber-500 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 disabled:bg-gray-100"
                              />
                            </div>
                          </div>
                          <div className="sm:col-span-2">
                            <label
                              htmlFor="company"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Company
                            </label>
                            <div className="mt-1 flex rounded-md shadow-sm">
                              <input
                                type="text"
                                name="company"
                                id="company"
                                disabled
                                value={company}
                                className="flex-1 focus:ring-amber-500 focus:border-amber-500 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 disabled:bg-gray-100"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="pt-5">
                    <div className="flex justify-start items-center">
                      <button
                        onClick={() => navigate("/v3/asic-exemptions")}
                        type="button"
                        disabled={loading}
                        className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        onClick={() => addExemption()}
                        disabled={loading || !asic || !asicDetails}
                        className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-60"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
